import { TrackingData } from '../directives';
import { TrackingEvent } from '../services';
import { NotificationType } from '../ui-models';

export function getTrackingData(name: string, type: NotificationType, value?: string): TrackingData {
	return { event: TrackingEvent.NotificationEvent, type, name, ...(value && { value }) };
}
